import {SET_ORG_TREE, SET_UNREAD_MESSAGE_INFO, SET_USER_AND_HOTEL_INFO, GET_CRM_UPDATE_CLOSE} from "./mutation-types";

export default {
  [SET_USER_AND_HOTEL_INFO] (state, info) {
    state.userInfo = info.user;
    if (info.user && info.user.username) {
      state.userInfo.userName = info.user.username;
    }
  },
  [SET_UNREAD_MESSAGE_INFO] (state, messages) {
    state.unreadMessageInfo = messages;
  },
  [SET_UNREAD_MESSAGE_INFO] (state, messages) {
    state.unreadMessageInfo = messages;
  },
  [SET_ORG_TREE] (state, messages){
    state.orgTree = messages;
  },
  [GET_CRM_UPDATE_CLOSE] (state, status) {
    state.crmUpdateClose = status;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js